import { visit } from 'unist-util-visit';
import type { Plugin } from 'unified';
import type { Root, Element } from 'hast';

/**
 * Rehype plugin to transform <reference> HTML elements into span elements
 * with data attributes that can be handled by the Reference component
 *
 * This plugin works after rehype-raw has parsed the HTML, transforming:
 * <reference name="docs" url="https://..." />
 * into:
 * <span data-reference="true" data-name="docs" data-url="https://..." />
 */
const rehypeReference: Plugin<[], Root> = () => {
  return (tree: Root) => {
    visit(tree, 'element', (node: Element) => {
      // Check if this is a <reference> element
      if (node.tagName === 'reference') {
        // Get the name and url attributes
        const name = node.properties?.name as string | undefined;
        const url = node.properties?.url as string | undefined;

        // Transform to a span with data attributes
        node.tagName = 'span';
        node.properties = {
          dataReference: true,
          dataName: name,
          dataUrl: url
        };
      }
    });
  };
};

export default rehypeReference;
